import { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { popupMsg } from "../../../../utils/popupMsg";

import SiteItem from "../SiteItem";
import AddSiteForm from "../AddSiteForm";

import { doGetSites } from "../../../../auth/api/doGetSites";
import { doAddSite } from "../../../../auth/api/doAddSites";
import { doUpdateSite } from "../../../../auth/api/doUpdateSites";
import { doDeleteSite } from "../../../../auth/api/doDeleteSites";

export const SiteManContext = createContext();

const SiteManContextProvider = (props) => {
  const { t } = useTranslation();
  const [sites, setSites] = useState([]);

  useEffect(() => {
    fetchSites();
  }, []);

  const fetchSites = async () => {
    try {
      const response = await doGetSites();
      if (response && response.success) {
        setSites(response.sites || []);
      } else if (Array.isArray(response)) {
        setSites(response);
      } else if (response) {
        popupMsg(response.function || "doGetSites", t(response.stack || "error"), t("Error"));
      }
    } catch (err) {
      popupMsg("doGetSites", t(err.message || err.stack), t("Error"));
    }
  };

  const headers = [
    "ObjectID",
    "ID Presenze",
    "Nome",
    "Tipologia",
    "Comune",
    "Localit\u00e0",
    "Stato Conservazione",
    "Compilatore",
    "Data",
    "Visibilit\u00e0",
  ];

  const addItemForm = AddSiteForm;
  const items = sites || [];

  const itemComponent = ({ item }) => <SiteItem item={item} />;

  const addSite = async (siteData) => {
    try {
      const response = await doAddSite(siteData);
      if (response && (response.success || response.geom_id || response.objectid_1)) {
        await fetchSites(); // Ricarica l'intera lista dal DB per includere descrizioni e note
      } else {
        popupMsg("addSite", t(response?.error || response?.stack || "Error"), t("Error"));
      }
      return response;
    } catch (err) {
      popupMsg("addSite", t(err.message || "Error"), t("Error"));
    }
  };

  const updateSite = async (siteId, siteData) => {
    try {
      const response = await doUpdateSite(siteId, siteData);
      if (response && (response.success || response.geom_id || response.objectid_1)) {
        await fetchSites(); // Ricarica la lista per sincronizzare note e descrizione aggiornate
      } else {
        popupMsg("updateSite", t(response?.error || response?.stack || "Error"), t("Error"));
      }
      return response;
    } catch (err) {
      popupMsg("updateSite", t(err.message || "Error"), t("Error"));
    }
  };

  const deleteSite = async (siteId) => {
    try {
      const response = await doDeleteSite(siteId);
      if (response && (response.success || response.message)) {
        setSites((prevSites) =>
          prevSites.filter((site) => (site.geom_id ?? site.objectid_1 ?? site.objectid) !== siteId)
        );
      } else {
        popupMsg("deleteSite", t(response?.error || response?.stack || "Error"), t("Error"));
      }
      return response;
    } catch (err) {
      popupMsg("deleteSite", t(err.message || "Error"), t("Error"));
    }
  };

  return (
    <SiteManContext.Provider
      value={{
        items,
        headers,
        itemComponent,
        addItemForm,
        addSite,
        updateSite,
        deleteSite,
        fetchSites, // Esposto in caso serva un refresh manuale
      }}
    >
      {props.children}
    </SiteManContext.Provider>
  );
};

export default SiteManContextProvider;